import goingDialogUtils from "./goingDialogUtils";
import classes from "./classes";
import {AssertUtils,GoingUtils} from "goingutils";
import GoingDialog from "./goingDialog";

var __dialogWindow = null;
var $dialog = null;


//弹出窗口控件
let goDialog = {
    //显示窗口loading
    showLoading(winId){
        let loadingId=GoingUtils.showLoading("",$("#layui-layer"+winId));
        goDialog.loadingId=loadingId;
        return loadingId;
    },
    //关闭窗口的loading
    closeLoading(winId,loadingId){
        if(!AssertUtils.isNotEmpty(loadingId)){
            loadingId=goDialog.loadingId;
        }
        GoingUtils.closeLoading($("#layui-layer"+winId),loadingId);
    },
    open: function (options) {
        let t = new GoingDialog(options);

        let {title, type} = options;
        if (!AssertUtils.isNotEmpty(title) && (type === 2 || type === 1)) {

            $(".layui-layer")
                .css("padding-top", "15px")
                .css("padding-right", "15px")
                .css("box-shadow", "none")
                .css("border", "none")
                .css("border-top", "0px");

            $(".layui-layer-setwin").css("right", "0px");
            $(".layui-layer-content")
                .css("border-top", "4px solid #0088FF")
                .css("overflow", "hidden");
        } else {
            $(".layui-layer-content").css("overflow", "hidden");
        }
        //如果用户自己定义了头部样式 则追加
        if(AssertUtils.isNotEmpty(options.headerClass)){
            $("#" + classes[0] + t.index).find(".layui-layer-title").addClass(options["headerClass"]);
        }
        //删除关闭类型 分remove 和 return remove表示关闭窗口的时候对象不需要回写到界面 return则表示对象需要回写到界面中
        $("#" + classes[0] + t.index).attr("closeType",options["closeType"]);
        return t.index;
    },
    v: "3.1.0",
    minIndex: 0,
    //le5 表示100000 1e5 === 100000返回true
    index: window.layer && window.layer.v ? 1e5 : 0,
    btn: ["&#x786E;&#x5B9A;", "&#x53D6;&#x6D88;"],
    path: goingDialogUtils.getPath(),
    config: function (e) {
        return (
            (e = e || {}),
                ((goingDialogUtils).cache = goDialog.config = $.extend(
                    {},
                    goDialog.config,
                    e
                )),
                ((goingDialogUtils).path =
                    (goDialog.config).path || (goingDialogUtils).path),
            "string" == typeof e.extend && (e.extend = [e.extend]),
            (goDialog.config).path && goDialog.ready(),
                e.extend ? (goingDialogUtils.link("theme/" + e.extend), this) : this
        );
    },
    ////初始化goingDialog的css文件
    ready: function () {
        // var t = "layer", i = "", n = "theme/default/GoingDialog.css?v=" + this.v + i;
        // //动态的导入css文件
        // return (goingDialogUtils).link(n, e, t), this;
    },
    //弹出alert 框
    alert: function (e, t, n) {
        var a = "function" == typeof t;
        return (
            a && (n = t),
                goDialog.open(
                    (goingDialogUtils).extend({content: e, yes: n}, a ? {} : t)
                )
        );
    },
    confirm: function (e, t, n, a) {
        var s = "function" == typeof t;
        return (
            s && ((a = n), (n = t)),
                goDialog.open(
                    (goingDialogUtils).extend(
                        {
                            content: e,
                            btn: goDialog.btn,
                            yes: function (index) {
                                n();
                                goDialog.close(index);
                            },
                            btn2: a
                        },
                        s ? {} : t
                    )
                )
        );
    },
    msg: function (e, n, a, t) {
        var s = "function" == typeof n,
            f = (goDialog.config).skin,
            c = (f ? f + " " + f + "-msg" : "") || "layui-layer-msg",
            u = classes.anim.length - 1;
        return (
            s && (a = n),
                goDialog.open(
                    $dialog.extend(
                        {
                            content: e,
                            time: 3e3,
                            shade: !1,
                            skin: c,
                            title: !1,
                            closeBtn: !1,
                            btn: !1,
                            resize: !1,
                            end: a
                        },
                        s && !(goDialog.config).skin
                            ? {skin: c + " layui-layer-hui", anim: u}
                            : (function () {
                                return (
                                    (n = n || {}),
                                    (n.icon === -1 ||
                                        (n.icon === t && !(goDialog.config).skin)) &&
                                    (n.skin = c + " " + (n.skin || "layui-layer-hui")),
                                        n
                                );
                            })()
                    )
                )
        );
    },
    load: function (e, t) {
        return goDialog.open(
            $dialog.extend({type: 3, icon: e || 0, resize: !1, shade: 0.01}, t)
        );
    },
    close: function (e) {
        let i = $;
        var t = i("#" + classes[0] + e),
            n = t.attr("type"),
            a = "layer-anim-close";
        let closeType=$(t).attr("closeType");
        //判断是否需要回填对象
        if(closeType==="return"){
            $(t)
                .find(".dialog-iframe")
                .each(function () {
                    var targetId = $(this).attr("targetId");
                    $("#" + targetId)
                        .hide()
                        .appendTo($("#main_router_view"));
                });

        }

        if (t[0]) {
            var s = "layui-layer-wrap",
                f = function () {
                    if (
                        n === (goingDialogUtils).type[1] &&
                        "object" === t.attr("conType")
                    ) {
                        t.children(":not(." + classes[5] + ")").remove();
                        for (var a = t.find("." + s), r = 0; r < 2; r++) a.unwrap();
                        a.css("display", a.data("display")).removeClass(s);
                    } else {
                        if (n === (goingDialogUtils).type[2]) {
                            var f = i("#" + classes[4] + e)[0];
                            if (f != null) {
                                (f.contentWindow).document.write(""),
                                    f.contentWindow.close(),
                                    t.find("." + classes[5])[0].removeChild(f);
                            }
                        }
                        (t[0].innerHTML = ""), t.remove();
                    }
                    "function" == typeof (goingDialogUtils).end[e] &&
                    (goingDialogUtils).end[e](),
                        delete (goingDialogUtils).end[e];
                };
            t.data("isOutAnim") && t.addClass("layer-anim " + a),
                i("#layui-layer-moves, #layui-layer-shade" + e).remove(),
            6 == (goingDialogUtils).ie && (goingDialogUtils).reselect(),
                (goingDialogUtils).rescollbar(e),
            t.attr("minLeft") &&
            (goDialog.minIndex--,
                (goingDialogUtils).minLeft.push(t.attr("minLeft"))),
                ((goingDialogUtils).ie && (goingDialogUtils).ie < 10) ||
                !t.data("isOutAnim")
                    ? f()
                    : setTimeout(function () {
                        f();
                    }, 200);
        }
    },
    closeAll: function (e) {
        var els = document.querySelectorAll("." + classes[0]);
        $.each(els, function (index, item) {
            var el = $(item).get(0);
            var n = e ? el.getAttribute("type") === e : 1;
            n && goDialog.close(el.getAttribute("times")), (n = null);
        });
    },
    tips: function (e, t, n) {
        return goDialog.open(
            $dialog.extend(
                {
                    type: 4,
                    content: [e, t],
                    closeBtn: !1,
                    time: 3e3,
                    shade: !1,
                    resize: !1,
                    fixed: !1,
                    maxWidth: 210
                },
                n
            )
        );
    },
    style(e, t, n) {
        var a = $("#" + classes[0] + e),
            r = a.find(".layui-layer-content"),
            s = a.attr("type"),
            f = a.find(classes[1]).outerHeight() || 0,
            c = a.find("." + classes[6]).outerHeight() || 0;
        a.attr("minLeft");
        s !== (goingDialogUtils).type[3] &&
        s !== (goingDialogUtils).type[4] &&
        (n ||
        (parseFloat(t.width) <= 260 && (t.width = 260),
        parseFloat(t.height) - f - c <= 64 && (t.height = 64 + f + c)),
            a.css(t),
            (c = a.find("." + classes[6]).outerHeight()),
            s === (goingDialogUtils).type[2]
                ? a.find("iframe").css({height: parseFloat(t.height) - f - c})
                : r.css({
                    height:
                        parseFloat(t.height) -
                        f -
                        c -
                        parseFloat(r.css("padding-top")) -
                        parseFloat(r.css("padding-bottom"))
                }));
    },
    run: function (t) {
        ($dialog = t), (__dialogWindow = $dialog(window)), (classes.html = $dialog("html"));
    }
};
goDialog.ready();
goDialog.run(window.jQuery);

export {$dialog, __dialogWindow};
export default goDialog;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingDialog/index.js